// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dash_container {
    width: 925px;
    margin: 0 auto;
    padding: 20px;
    /* padding-bottom: 25px; */
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;

    font-family: "Montserrat", sans-serif;
}

.Dash_progress {
    min-height: 5px;
    margin: -15px -20px 15px -20px;
    background-color: #e4e4e4;
}

.Dash_progress_completed {
    height: 100%;
    background-color: #CC2500;
}

.Dash_mainTabs {
    display: flex;
    justify-content: space-between;
}

.Dash_mainTab {
    margin-bottom: 15px;
    padding: 10px 15px;

    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    background-color: #f0f0f0;
    color: #555;
    transition: background-color 0.3s ease, color 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    display: flex;
    align-items: center;
    gap: 10px;
}

.Dash_mainTab:hover {
    background-color: #e0e0e0;
}

.Dash_mainTab.selected {
    background-color: #A14B51;
    color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.Dash_mainTab_icon {
    height: 15px;
}

.Dash_mainTab.selected > .Dash_mainTab_icon {
    filter: brightness(0) invert(1);
}

.Dash_subTabs {
    display: flex;
    font-size: 10px;
    font-weight: 600;

    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    width: -moz-fit-content;

    width: fit-content;
}

.Dash_subTabs > div:last-child {
    border-right: 1px solid #e4e4e4;
}

.Dash_subtab {
    border: 1px solid #e4e4e4;
    border-bottom: none;
    border-right: none;
    background: #fff;
    padding: 0 15px;
    height: 30px;
    line-height: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    font-weight: 500;
}

.Dash_subtab.selected {
    border-top: 2px solid #BCB4AC;
    font-weight: 600;
}

.Dash_content {
    border: 1px solid #e4e4e4;
    border-radius: 12px;
    border-top-left-radius: 0;
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    display: flex;
    flex-direction: column;
    flex-grow: 1;

    overflow: hidden;

    position: relative;
}

.Dash_content_body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/screens/StartNew/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;;IAEhB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,uDAAuD;IACvD,wCAAwC;;IAExC,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;;IAEhB,wCAAwC;;IAExC,uBAAkB;;IAAlB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,wCAAwC;;IAExC,aAAa;IACb,sBAAsB;IACtB,YAAY;;IAEZ,gBAAgB;;IAEhB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".Dash_container {\n    width: 925px;\n    margin: 0 auto;\n    padding: 20px;\n    /* padding-bottom: 25px; */\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow: hidden;\n\n    font-family: \"Montserrat\", sans-serif;\n}\n\n.Dash_progress {\n    min-height: 5px;\n    margin: -15px -20px 15px -20px;\n    background-color: #e4e4e4;\n}\n\n.Dash_progress_completed {\n    height: 100%;\n    background-color: #CC2500;\n}\n\n.Dash_mainTabs {\n    display: flex;\n    justify-content: space-between;\n}\n\n.Dash_mainTab {\n    margin-bottom: 15px;\n    padding: 10px 15px;\n\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    border-radius: 5px;\n    background-color: #f0f0f0;\n    color: #555;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.Dash_mainTab:hover {\n    background-color: #e0e0e0;\n}\n\n.Dash_mainTab.selected {\n    background-color: #A14B51;\n    color: #fff;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.Dash_mainTab_icon {\n    height: 15px;\n}\n\n.Dash_mainTab.selected > .Dash_mainTab_icon {\n    filter: brightness(0) invert(1);\n}\n\n.Dash_subTabs {\n    display: flex;\n    font-size: 10px;\n    font-weight: 600;\n\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n    width: fit-content;\n}\n\n.Dash_subTabs > div:last-child {\n    border-right: 1px solid #e4e4e4;\n}\n\n.Dash_subtab {\n    border: 1px solid #e4e4e4;\n    border-bottom: none;\n    border-right: none;\n    background: #fff;\n    padding: 0 15px;\n    height: 30px;\n    line-height: 8px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    box-sizing: border-box;\n    font-weight: 500;\n}\n\n.Dash_subtab.selected {\n    border-top: 2px solid #BCB4AC;\n    font-weight: 600;\n}\n\n.Dash_content {\n    border: 1px solid #e4e4e4;\n    border-radius: 12px;\n    border-top-left-radius: 0;\n    background-color: #ffffff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    overflow: hidden;\n\n    position: relative;\n}\n\n.Dash_content_body {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
